import React from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import { logoutuser } from "../_redux/authCrud";
import * as auth from "../_redux/authRedux";

const Logout = (props) => {
  const navigate = useNavigate();
  const { user } = props;
  console.log("🚀 ~ Logout ~ props:", props)
  if (user) {
    logoutuser(user.user.username)
  };


  React.useEffect(() => {
    navigate('/');
    props.logout();
    console.log('navigate /')
  }, [])
}

// export default connect(({ auth }) => ({ hasAuthToken: Boolean(auth.authToken), user: auth.user }), auth.actions)(Logout);
export default connect(
  ({ auth }) => ({ hasAuthToken: Boolean(auth.authToken), user: auth.user }),
  auth.actions
)(Logout);


// class Logout extends Component {
//     componentDidMount() {
//         // console.log(this.props);

//         const { user } = this.props;
//         // console.log(user);
//         if (user) {
//             logoutuser(user.user.username)
//         };
//         this.props.logout();
//     }

//     render() {
//         // console.log(this.props);
//         const { hasAuthToken } = this.props;
//         return hasAuthToken ? <LayoutSplashScreen /> : <Redirect to="/" />;
//     }
// }

// export default connect(
//     ({ auth }) => ({ hasAuthToken: Boolean(auth.authToken), user: auth.user }),
//     auth.actions
// )(Logout);
